import { VText } from '@vake/ui-kit';
import { FC, useEffect, useState } from 'react';
import { PageContentWrapper } from '../shared/styles/wrappers';

interface IJobItem {
    title: string;
    description: JSX.Element;
    defaultOpen: boolean;
}

const JobItem: FC<IJobItem> = ({ title, description, defaultOpen }) => {
    const [open, setOpen] = useState<boolean>(defaultOpen);
    return (
        <div>
            <div className="cursor-pointer" onClick={() => setOpen(!open)}>
                <VText variant="H2">
                    {open ? '-' : '+'} {title}
                </VText>
            </div>
            {open && description}
        </div>
    );
};

const JobList: IJobItem[] = [
    {
        title: 'Master or Bachelor Thesis',
        description: (
            <>
                <VText>
                    <b>NB:</b> We have reached our limit for supervised theses for the academic year 2025/2026
                    <br />
                    <br />
                </VText>
                <VText>
                    Are you a student that specializes in geoinformatics, computer science, cybernetics, marine
                    technology or similar fields of study? You should consider writing a thesis in collaboration with
                    us! Vake has connections to scientific communities at NTNU, NHH, and UIT, and believes student
                    research adds great value to our mission. We have previously supervised twelve master theses, and
                    are seeking new engaged students to do projects within computer vision, machine learning, onboard
                    satellite processing, vessel position prediction or time-series analysis.
                </VText>
            </>
        ),
        defaultOpen: false,
    },
    {
        title: 'Winter Internship',
        description: (
            <>
                <ul>
                    <li>
                        <VText>
                            We aren't planning any internship positions this winter. Our next recruitment cycle for
                            internships is scheduled for autumn 2026. Keep an eye on this space for detailed
                            announcements closer to that time.
                        </VText>
                    </li>
                    <li>
                        <VText>Duration: 6 weeks</VText>
                    </li>
                    <li>
                        <VText>
                            With experience from six previously successful internships, we look for 3rd, 4th, and
                            5th-year students who are ready to make a real impact.
                        </VText>
                    </li>
                    <li>
                        <VText>
                            You will be a part of integrating new satellite sources, training deep learning models or
                            work full-stack on our API and frontend solutions. We will tailor tasks to your interests,
                            and we guarantee you will learn a lot.
                        </VText>
                    </li>
                </ul>
            </>
        ),
        defaultOpen: true,
    },
];

const Careers: FC = () => {
    useEffect(() => {
        document.title = 'Careers';
    }, []);

    return (
        <PageContentWrapper>
            <div className="flex flex-wrap justify-between">
                <div className="flex flex-col justify-center w-1/2 gap-4">
                    <VText variant="Di2">Careers</VText>
                    <VText>
                        As an emerging machine learning company in the space domain, we believe we can offer exciting
                        opportunities working with cutting edge technology and innovation.{' '}
                        <a className="underline" href="mailto:connect@vake.ai">
                            Reach out and introduce yourself
                        </a>
                        , lets make something happen!
                    </VText>

                    {JobList.map((item, i) => (
                        <JobItem key={`job_${i}`} {...item} />
                    ))}
                </div>
                <div className="flex items-center flex-col">
                    <video autoPlay muted loop className="w-[500px] h-auto max-w-[calc(100%-20px)] mx-auto">
                        <source src="images/about/Sentinel.mp4" type="video/mp4" />
                    </video>
                    <VText variant="D1" significance="secondary">
                        Visualization of Sentinel 2A in orbit, one of our main data sources
                    </VText>
                </div>
            </div>
        </PageContentWrapper>
    );
};

export default Careers;
